(function () {
  // Delay matches the drawer slide-out transition (0.3s) so panels reset
  // after the drawer is fully closed — avoids visible snap-back during animation.
  const DRAWER_TRANSITION_MS = 300;

  function resetSecondaryNav() {
    setTimeout(function () {
      const panels = document.getElementsByClassName('mob-secondary-level-ul');
      const slHideDivs = document.getElementsByClassName('sl-hide');
      for (let i = 0; i < panels.length; i++) panels[i].classList.remove('active');
      for (let i = 0; i < slHideDivs.length; i++) slHideDivs[i].classList.remove('sl-hide-oi');
    }, DRAWER_TRANSITION_MS);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const closeBtn = document.getElementById('mobNavDrawerClose');
    const bg = document.getElementById('drawBg');
    if (closeBtn) closeBtn.addEventListener('click', resetSecondaryNav);
    if (bg) bg.addEventListener('click', resetSecondaryNav);
  });
})();
